import { SelectPractitionerScreenWithBookingData } from "~/features/book-appointment/SelectPractitionerScreen";

const Component = () => {
  return <SelectPractitionerScreenWithBookingData />;
};

export default Component;
